import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

function CurrentlyWorkingFor() {
  return (
    <Box sx={{ justifySelf: 'center', background: '#ffffff00', width: '90%', minWidth: 720, marginLeft: 'auto', marginRight: 'auto' }}>
      <Card variant="outlined" sx={{ background: '#fffaf0eb', width: '100%' }}>
          <CardContent sx={{ textAlign: 'left' }}>
            <Typography sx={{ color: 'gray' }}>
              Currently Working For
            </Typography>
            <Typography variant="h5">
              Remmie Health
            </Typography>
            <Typography variant="h7">
              Software Engineer
            </Typography>
            <br />
            <br />
            <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ color: 'gray' }}>
              Tech Stack 🛠️
            </AccordionSummary>
            <AccordionDetails variant="h6">
              <ul>
                <li>Python</li>
                <li>PHP</li>
                <li>C# / .NET</li>
                <li>React Native</li>
                <li>TypeScript</li>
              </ul>
            </AccordionDetails>
            </Accordion>
          </CardContent>
      </Card>
    </Box>
  );
}

export default CurrentlyWorkingFor;
